module.exports = __webpack_public_path__ + "static/media/socialsw.6f2e5212.png";